var React = require('react');

function CheckboxDropdownChecked (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"11.5","y":"11.5","width":"17","height":"17","fill":"#1A237E","stroke":"#1A237E","key":0}),React.createElement("path",{"d":"M18 24.4L14 20.4L15.4 19L18 21.6L24.6 15L26 16.4L18 24.4Z","fill":"white","key":1})]);
}

CheckboxDropdownChecked.defaultProps = {"fill":"none","viewBox":"11 11 18 18"};

module.exports = CheckboxDropdownChecked;

CheckboxDropdownChecked.default = CheckboxDropdownChecked;
